import React from "react";
import Grid from "@mui/material/Grid";
import { getAssets } from "@unisearch/helpers";
import { FiSearch } from "react-icons/fi";
import styles from "./mentor_hero.module.scss";
import Image from "next/legacy/image";

export const MentorHero = () => {
  return (
    <section className={styles.section_hero}>
      <div className="container">
        <Grid container spacing={2} alignItems="center">
          <Grid item sm={12} md={6}>
            <h1 className={styles.title}>
              Find Your Study Abroad <span className={"mark"}>Mentor</span>{" "}
            </h1>
            <p className={`${styles.sub_title} font-medium`}>
              Having questions and concerns about studying abroad? Who better to
              answer them than students currently abroad themselves! Connect
              with student mentors from your prospective study abroad
              destination.
            </p>
          </Grid>
          <Grid item sm={12} md={6}>
            <div className={styles.image_wrapper}>
              <Image
                layout="responsive"
                width={573}
                height={430}
                blurDataURL={getAssets(
                  "assets/images/study/country_placeholder.webp"
                )}
                placeholder="blur"
                src={getAssets("assets/images/mentor/mentor_hero.webp")}
                alt="hero image"
              />
            </div>
          </Grid>
        </Grid>
      </div>
    </section>
  );
};

export default MentorHero;
